import React, {useEffect, useState, useRef} from "react";
import {Dropdown} from "primereact/dropdown";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {setQueueField, toggleDayActive, updateDayTime} from "../../../redux/actions/actionsQueue";
import {Checkbox} from "primereact/checkbox";
import {InputText} from "primereact/inputtext";
import {Calendar} from 'primereact/calendar';
import moment from "moment/moment";
import {classNames} from "primereact/utils";

interface SchedulerType {
    name: string;
    typeScheduler: number;
}

const QueueWorkSetting = () => {
    moment.suppressDeprecationWarnings = true;
    const dispatch = useAppDispatch();
    // @ts-ignore
    const queueData = useAppSelector(state => state.QueueListReducer.queueData);
    const queueScheduler = queueData?.scheduler;
    // @ts-ignore
    const errorFields = useAppSelector(state => state.QueueListReducer.errorFields);
    const editType = useAppSelector(state => state.UsersReducer.editType);
    // @ts-ignore
    const archiveTableToggle = useAppSelector(state => state.QueueListReducer.archiveQueueTableToggle);
    const [updatedScheduler, setUpdatedScheduler] = useState<any>({
        "typeScheduler": 402,
        "days": [
            {
                "label": "Понеділок",
                "dayOfWeek": 1
            },
            {
                "label": "Вівторок",
                "dayOfWeek": 2
            },
            {
                "label": "Середа",
                "dayOfWeek": 3
            },
            {
                "label": "Четвер",
                "dayOfWeek": 4
            },
            {
                "label": "П'ятниця",
                "dayOfWeek": 5
            },
            {
                "label": "Субота",
                "dayOfWeek": 6
            },
            {
                "label": "Неділя",
                "dayOfWeek": 0
            }
        ]
    });

    const previousTimeValues = useRef<{[key: string]: {start?: string, end?: string}}>({});
    const schedulerTypes: SchedulerType[] = [
        {name: 'Дні тижня', typeScheduler: 402},
    ];

    const weekdayField = [
        {label: 'Понеділок', dayOfWeek: 1},
        {label: 'Вівторок', dayOfWeek: 2},
        {label: 'Середа', dayOfWeek: 3},
        {label: 'Четвер', dayOfWeek: 4},
        {label: 'П\'ятниця', dayOfWeek: 5},
        {label: 'Субота', dayOfWeek: 6},
        {label: 'Неділя', dayOfWeek: 0}
    ];

    useEffect(() => {
        if (queueScheduler && queueScheduler?.days) {
            const updatedDays = weekdayField.map(weekday => {
                const matchingDay = queueScheduler?.days?.find((day: { dayOfWeek: number; }) => day.dayOfWeek === weekday.dayOfWeek);

                if (matchingDay) {
                    return {...weekday, ...matchingDay};
                }

                return weekday;
            });

            setUpdatedScheduler({...queueScheduler, days: updatedDays});
        } else {
        }
    }, [queueScheduler]);

    const isValidDate = (value: any) => {
        const format = 'MM/DD/YYYY';
        return moment(value, format, true).isValid();
    };

    const handleDateChange = (date: any) => {
        return moment(date).format('MM/DD/YYYY HH:mm:ss');
    };

    const transformToDate = (dateString: any) => {
        return new Date(moment(dateString).format('MM/DD/YYYY HH:mm:ss'));
    }

    const createDefaultTime = (isStart: boolean) => {
        const today = new Date();
        if (isStart) {
            today.setHours(0, 0, 0, 0); // 00:00 для поля "З"
        } else {
            today.setHours(23, 59, 0, 0); // 23:59 для поля "По"
        }
        return handleDateChange(today);
    };

    const getTimeValue = (dayOfWeek: number, type: 'start' | 'end') => {
        const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === dayOfWeek);
        if (dayData && dayData[type]) {
            return transformToDate(dayData[type]);
        }
        return null;
    };

    const handleTimeFocus = (dayOfWeek: number, type: 'start' | 'end') => {
        const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === dayOfWeek);
        if (dayData && dayData[type]) {
            if (!previousTimeValues.current[dayOfWeek]) {
                previousTimeValues.current[dayOfWeek] = {};
            }
            previousTimeValues.current[dayOfWeek][type] = dayData[type];
            dispatch(updateDayTime(dayOfWeek, null, type));
        }
    };

    const handleTimeBlur = (dayOfWeek: number, type: 'start' | 'end') => {
        const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === dayOfWeek);
        if (!dayData || !dayData[type]) {
            const previousValue = previousTimeValues.current[dayOfWeek]?.[type];
            const valueToSet = previousValue || createDefaultTime(type === 'start');
            dispatch(updateDayTime(dayOfWeek, valueToSet, type));
        }
    };
    return (
        <div className="grid p-fluid">
            <div className="field col-12 md:col-6 mb-0">
                <Dropdown
                    filter
                    value={queueData?.scheduler?.typeScheduler || 402}
                    onChange={(e) => {
                        dispatch(setQueueField({section: 'scheduler', fieldName: 'typeScheduler', value: e.value}));
                    }}
                    disabled={!archiveTableToggle || !editType}
                    options={schedulerTypes}
                    optionLabel="name"
                    optionValue="typeScheduler"
                    placeholder="Виберіть тип:" className="w-full py-2"
                />
            </div>
            <div className="field col-12 md:col-6"></div>
            <div className="field col-12 md:col-6">
                <label className={classNames('mb-3 font-bold', {'p-error': errorFields?.scheduler || errorFields?.scheduler})}>Розклад дзвінків</label>
                {updatedScheduler?.days?.map((field: any, index: number) => (
                    <div className="field col-12 md:col-12 mb-0 p-0" key={index}>
                        <div className="grid align-items-center">
                            <div className="col-12 md:col-4">
                                <InputText type="text" value={field.label} className="opacity-100 w-full" placeholder={field.label} disabled/>
                            </div>
                            <div className="col-2 md:col-2 flex justify-content-center">
                                <Checkbox
                                    disabled={!archiveTableToggle || !editType}
                                    className={classNames('opacity-100', {'p-invalid': errorFields?.scheduler && !updatedScheduler?.days})}
                                    checked={!!queueScheduler?.days?.find((day: { dayOfWeek: any; }) => day.dayOfWeek === field.dayOfWeek)}
                                    onChange={(e) => {
                                        dispatch(toggleDayActive(field.dayOfWeek, e.checked));
                                        if (e.checked) {
                                            const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === field.dayOfWeek);
                                            if (!dayData?.start) {
                                                dispatch(updateDayTime(field.dayOfWeek, createDefaultTime(true), 'start'));
                                            }
                                            if (!dayData?.end) {
                                                dispatch(updateDayTime(field.dayOfWeek, createDefaultTime(false), 'end'));
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-6 md:col-3 flex align-items-center">
                                <div className="mr-2">
                                    <label>З</label>
                                </div>
                                <Calendar
                                    key={`start-queue-${field.dayOfWeek}-${!!queueScheduler?.days?.find((day: { dayOfWeek: any; }) => day.dayOfWeek === field.dayOfWeek)}`}
                                    className={classNames('opacity-100', {'p-invalid': errorFields?.scheduler && !updatedScheduler?.days})}
                                    disabled={!archiveTableToggle || !editType || !queueScheduler?.days?.find((day: { dayOfWeek: any; }) => day.dayOfWeek === field.dayOfWeek)}
                                    value={getTimeValue(field.dayOfWeek, 'start')}
                                    onChange={e => {
                                        if (isValidDate(e.target.value)) {
                                            const newTime = handleDateChange(e.target.value);
                                            dispatch(updateDayTime(field.dayOfWeek, newTime, 'start'));
                                        }
                                    }}
                                    placeholder="00:00"
                                    timeOnly
                                    hourFormat="24"
                                    onFocus={() => handleTimeFocus(field.dayOfWeek, 'start')}
                                    onBlur={() => handleTimeBlur(field.dayOfWeek, 'start')}
                                    onInput={(e: any) => {
                                        const input = e.target as HTMLInputElement;

                                        let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                        const HH = digits.slice(0, 2);
                                        const MM = digits.slice(2, 4);

                                        const display = HH + (digits.length > 2 ? ":" + MM : "");

                                        if (input.value !== display) {
                                            const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                            input.value = display;
                                            input.setSelectionRange(caret, caret);
                                        }

                                        if (digits.length === 4) {
                                            const h = parseInt(HH, 10);
                                            const m = parseInt(MM, 10);
                                            const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                            if (valid) {
                                                const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === field.dayOfWeek);
                                                const base = dayData?.start ? new Date(dayData.start) : new Date();
                                                base.setHours(h, m, 0, 0);
                                                const newTime = handleDateChange(base);
                                                dispatch(updateDayTime(field.dayOfWeek, newTime, 'start'));
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-6 md:col-3 flex align-items-center">
                                <div className="mr-2">
                                    <label>По</label>
                                </div>
                                <Calendar
                                    key={`end-queue-${field.dayOfWeek}-${!!queueScheduler?.days?.find((day: { dayOfWeek: any; }) => day.dayOfWeek === field.dayOfWeek)}`}
                                    disabled={!archiveTableToggle || !editType || !queueScheduler?.days?.find((day: { dayOfWeek: any; }) => day.dayOfWeek === field.dayOfWeek)}
                                    className={classNames('opacity-100', {'p-invalid': errorFields?.scheduler && !updatedScheduler?.days})}
                                    value={getTimeValue(field.dayOfWeek, 'end')}
                                    onChange={e => {
                                        if (isValidDate(e.target.value)) {
                                            const newTime = handleDateChange(e.target.value);
                                            dispatch(updateDayTime(field.dayOfWeek, newTime, 'end'));
                                        }
                                    }}
                                    placeholder="00:00"
                                    timeOnly
                                    hourFormat="24"
                                    onFocus={() => handleTimeFocus(field.dayOfWeek, 'end')}
                                    onBlur={() => handleTimeBlur(field.dayOfWeek, 'end')}
                                    onInput={(e: any) => {
                                        const input = e.target as HTMLInputElement;

                                        let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                        const HH = digits.slice(0, 2);
                                        const MM = digits.slice(2, 4);

                                        const display = HH + (digits.length > 2 ? ":" + MM : "");

                                        if (input.value !== display) {
                                            const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                            input.value = display;
                                            input.setSelectionRange(caret, caret);
                                        }

                                        if (digits.length === 4) {
                                            const h = parseInt(HH, 10);
                                            const m = parseInt(MM, 10);
                                            const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                            if (valid) {
                                                const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === field.dayOfWeek);
                                                const base = dayData?.end ? new Date(dayData.end) : new Date();
                                                base.setHours(h, m, 0, 0);
                                                const newTime = handleDateChange(base);
                                                dispatch(updateDayTime(field.dayOfWeek, newTime, 'end'));
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="grid col-12 md:col-12 pt-0">
                {errorFields?.scheduler && <div className="col-12 md:col-12 p-0 m-0 pl-2 mb-2"><span className="title p-error text-sm">{errorFields?.scheduler?.scheduler}</span></div>}
            </div>
        </div>
    );
};

export default QueueWorkSetting;
